export const priceLists = {
  fr: {
    title: "Liste de prix",
    sections: [
      {
        id: "baignoires-tole-fonte",
        heading: "Baignoires (tôle et fonte)",
        rows: [
          { service: "Réémaillage d'une baignoire encastrée en fonte ou en tôle émaillée", price: "385 $" },
          { service: "Baignoire sur pattes — intérieur seulement (fonte)", price: "385 $" },
          { service: "Remplissage des trous de robinet pour l'installation d'une robinetterie externe", price: "50 $" },
          { service: "Supplément pour une baignoire ayant déjà été réémaillée", price: "90 $ à 140 $" },
          {
            service: "Supplément pour une baignoire dont le fond est très abîmé",
            note: "Dommages causés notamment par un tapis de bain, des antidérapants en forme de fleurs ou un produit acide pour le drain.",
            price: "80 $ à 120 $"
          },
          { service: "Supplément pour changement de couleur (couche supplémentaire)", price: "45 $" }
        ]
      },
      {
        id: "baignoires-acrylique",
        heading: "Baignoires en acrylique",
        rows: [
          { service: "Rénovation d'une baignoire en acrylique une place", price: "450 $ à 525 $" },
          { service: "Rénovation d'une baignoire tourbillon une place", price: "475 $ à 550 $" },
          { service: "Réparation locale de fissures et de bris sur une baignoire ou une douche en acrylique", price: "225 $ à 340 $" },
          { service: "Polissage d'une baignoire en acrylique", price: "180 $ à 280 $" }
        ]
      },
      {
        id: "baignoires-sur-dimensionnees",
        heading: "Baignoires surdimensionnées",
        rows: [
          { service: "Baignoires thérapeutiques et tourbillons de différentes formes", price: "480 $ à 1 800 $" }
        ]
      },
      {
        id: "extraction-coquille",
        heading: "Extraction d'une coquille rigide",
        rows: [
          {
            service: "Extraction d'une coquille rigide, nettoyage de la colle et réémaillage de la baignoire d'origine",
            price: "1 100 $ à 1 200 $"
          }
        ]
      },
      {
        id: "ceramique-accessoires",
        heading: "Céramique et accessoires",
        rows: [
          { service: "Réémaillage de la céramique", price: "10 $ / pi²" },
          {
            service: "Réémaillage des accessoires",
            note: "Exemples : porte-savon, porte-serviette et distributeur de papier hygiénique.",
            price: "15 $ à 25 $ / unité"
          }
        ]
      },
      {
        id: "douche-base",
        heading: "Douche et base de douche",
        rows: [
          { service: "Base de douche", price: "345 $" },
          { service: "Cabine de douche", price: "450 $ à 650 $" }
        ]
      },
      {
        id: "evier",
        heading: "Réémaillage d'éviers en fonte ou en tôle émaillée",
        rows: [
          { service: "Simple cuve", price: "385 $" },
          { service: "Simple cuve avec égouttoir", price: "450 $" },
          { service: "Double cuve", price: "475 $ à 525 $" },
          { service: "Supplément pour un évier ayant déjà été réémaillé", price: "90 $ à 140 $" }
        ]
      },
      {
        id: "frais-deplacement",
        heading: "Frais de déplacement",
        rows: [
          {
            service: "Zone 1 : montant fixe",
            note: "Environs immédiats de Montréal : Longueuil, Brossard, Boucherville, Repentigny et Laval.",
            price: "25 $"
          },
          {
            service: "Zones 2 et 3 : frais au kilomètre",
            note: "Calculés à partir de nos bureaux à Montréal (H1B 4T2).",
            price: "1 $ / km"
          }
        ]
      }
    ]
  },
  en: {
    title: "Price List",
    sections: [
      {
        id: "baignoires-tole-fonte",
        heading: "Bathtubs (enameled steel and cast iron)",
        rows: [
          { service: "Refinishing of a built-in cast-iron or enameled-steel bathtub", price: "$385" },
          { service: "Clawfoot bathtub — interior only (cast iron)", price: "$385" },
          { service: "Filling faucet holes for the installation of external fixtures", price: "$50" },
          { service: "Surcharge for a bathtub that has already been refinished", price: "$90 to $140" },
          {
            service: "Surcharge for a bathtub with a heavily damaged bottom",
            note: "Damage caused by items such as a bath mat, flower-shaped anti-slip decals or acidic drain products.",
            price: "$80 to $120"
          },
          { service: "Color-change surcharge (additional coat)", price: "$45" }
        ]
      },
      {
        id: "baignoires-acrylique",
        heading: "Acrylic Bathtubs",
        rows: [
          { service: "Renovation of a standard one-person acrylic bathtub", price: "$450 to $525" },
          { service: "Renovation of a one-person whirlpool bathtub", price: "$475 to $550" },
          { service: "Local repair of cracks and damage on an acrylic bathtub or shower", price: "$225 to $340" },
          { service: "Polishing of an acrylic bathtub", price: "$180 to $280" }
        ]
      },
      {
        id: "baignoires-sur-dimensionnees",
        heading: "Oversized Bathtubs",
        rows: [
          { service: "Therapeutic bathtubs and whirlpools in various shapes", price: "$480 to $1,800" }
        ]
      },
      {
        id: "extraction-coquille",
        heading: "Rigid Shell Removal",
        rows: [
          {
            service: "Removal of a rigid shell, adhesive cleanup and refinishing of the original bathtub",
            price: "$1,100 to $1,200"
          }
        ]
      },
      {
        id: "ceramique-accessoires",
        heading: "Ceramic and Accessories",
        rows: [
          { service: "Ceramic refinishing", price: "$10 / sq. ft." },
          {
            service: "Accessory refinishing",
            note: "Examples: soap dish, towel bar and toilet-paper holder.",
            price: "$15 to $25 / unit"
          }
        ]
      },
      {
        id: "douche-base",
        heading: "Shower and Shower Base",
        rows: [
          { service: "Shower base", price: "$345" },
          { service: "Shower enclosure", price: "$450 to $650" }
        ]
      },
      {
        id: "evier",
        heading: "Refinishing of Cast-Iron or Enameled-Steel Sinks",
        rows: [
          { service: "Single bowl", price: "$385" },
          { service: "Single bowl with drainboard", price: "$450" },
          { service: "Double bowl", price: "$475 to $525" },
          { service: "Surcharge for a sink that has already been refinished", price: "$90 to $140" }
        ]
      },
      {
        id: "frais-deplacement",
        heading: "Travel Fees",
        rows: [
          {
            service: "Zone 1: flat fee",
            note: "Immediate Montreal area: Longueuil, Brossard, Boucherville, Repentigny and Laval.",
            price: "$25"
          },
          {
            service: "Zones 2 and 3: per-kilometre fee",
            note: "Calculated from our Montreal office (H1B 4T2).",
            price: "$1 / km"
          }
        ]
      }
    ]
  }
};
